var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeProperty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68.5714,
    height: 68.5714,
    rx: 34.2857,
    fill: "#1C3988"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2859 28.9523V22.2856H22.2859V30.2856L24.9526 34.2856V46.2856M27.6192 22.2856V24.9523M32.9526 22.2856V24.9523M31.6192 39.619L37.5175 34.2568C38.0243 33.7962 38.2776 33.5658 38.5647 33.4786C38.8176 33.4016 39.0875 33.4016 39.3404 33.4786C39.6275 33.5658 39.8808 33.7962 40.3876 34.2568L46.2859 39.619M34.2859 37.1947V44.1523C34.2859 44.8991 34.2859 45.2724 34.4312 45.5576C34.5591 45.8086 34.763 46.0124 35.0139 46.1403C35.2991 46.2856 35.6724 46.2856 36.4192 46.2856H41.4859C42.2327 46.2856 42.606 46.2856 42.8912 46.1403C43.1422 46.0124 43.346 45.8086 43.4739 45.5576C43.6192 45.2724 43.6192 44.8991 43.6192 44.1523V37.1947M32.9526 30.2856H27.6192",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProperty);
export default __webpack_public_path__ + "static/media/homeProperty.dedfce4b37e45b532325e766fc20565c.svg";
export { ForwardRef as ReactComponent };